module.exports = __webpack_public_path__ + "visa_card.png?719ee10473701439a06043f221226585";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/visa_card.png
// module id = 469
// module chunks = 0